<template>
  <div class="main">
    <dv-border-box-10>
      <el-row class="row_title">
        <el-col :span="4" :offset="0">
          <span>{{ title }}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" :offset="0">
          <dv-scroll-ranking-board
            class="scroll_ranking_board"
            :config="config"
          />
        </el-col>
      </el-row>
    </dv-border-box-10>
  </div>
</template>

<style scoped>
.main {
  width: 100%;
  height: 100%;
  color: rgb(221, 146, 146);
}

.row_title {
  padding-top: 2vh;
  text-align: left;
  font-size: 25px;
  padding-left: 30px;
}

.scroll_ranking_board {
  width: 98%;
  height: 100vh;
  color: rgb(221, 146, 146);
  margin: auto;
}
</style>

<script>
import Vue from "vue";
import DataV from "@jiaminghi/data-view";

Vue.use(DataV);

export default {
  props: {
    dataVal: {
      type: Object, //指定传入的类型,type 也可以是一个自定义构造器函数，使用 instanceof 检测。
      default: null,
    },
  },
  name: "DataVHeader2",
  data() {
    return {
      key: 1,
      dataInfo: this.dataVal,
      title: this.dataVal.title,
      config: this.dataVal.scrollData,
    };
  },
  mounted() {
    window.addEventListener("resize", () => this.onWindowResize(), false);
  },
  methods: {
    onWindowResize: function() {
      this.key += 1;
      this.$nextTick;
    },
  },
};
</script>
